/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Save_Context_Unavailable_ToastInputs */



/**
* | output |
* | --- |
* | "Opening search results is not available while overwriting. Open the folder first." |
*
* @param {Explorer_Search_Save_Context_Unavailable_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_save_context_unavailable_toast = /** @type {((inputs?: Explorer_Search_Save_Context_Unavailable_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Save_Context_Unavailable_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
	return /** @type {LocalizedString} */ ("Opening search results is not available while overwriting. Open the folder first.")
});